export const GENESYS_ENVIRONMENT = import.meta.env.VITE_GENESYS_ENVIRONMENT;
export const GENESYS_DEPLOYMENT_ID = import.meta.env.VITE_GENESYS_DEPLOYMENT_ID;
export const GENESYS_SCRIPT_URL = import.meta.env.VITE_GENESYS_SCRIPT_URL;
export const GENESYS_DEBUG = import.meta.env.VITE_GENESYS_DEBUG === "true";
